let Carousel = require('../components/Carousel');

class Popup {
    constructor(selectors = '', carouselSelector = '') {
        this._triggers = [];

        if (selectors !== '') {
            this._triggers = document.querySelectorAll(selectors);
        }

        this._main = document.getElementsByTagName('main')[0];
        this._carouselSelector = carouselSelector;

        this._createListener();

    }

    _createListener() {
        let targets = [];
        for (let trigger of this._triggers) {
            if (!trigger.hasAttribute('data-target')) {
                console.warn('Target need a data*target')
            } else {
                let target = document.querySelector(trigger.getAttribute('data-target'));

                if (targets.indexOf(trigger) === -1 && target) {
                    trigger.addEventListener('click', () => {
                        this.open(target);
                    });

                    this._closeListener(target);

                    targets.push(trigger);
                }
            }
        }
    }

    _closeListener(target) {

        target.addEventListener('click', (e) => {
            if (e.target === target) {
                this.close(target);
            }
        });

        document.getElementsByTagName('header')[0].addEventListener('click', () => {
            this.close(target);
        });

        target.addEventListener('animationend', function (e) {
            if (target.classList.contains('hide')) {
                target.classList.remove('hide');
            }
        });

        let closeButtons = target.getElementsByClassName('js-popup-close');

        for (let btn of closeButtons) {
            btn.addEventListener('click', () => {
                this.close(target);
            });
        }
    }

    open(target) {
        this._main.classList.add('popup-open');
        target.classList.add('show');
        if (this._triggers.length === 0) {
            this._closeListener(target);
        }

        document.body.style.overflow = 'hidden';

        if (this._carouselSelector !== '') {
            let carousel = target.getElementsByClassName(this._carouselSelector)[0];

            if (!carousel.classList.contains('carousel')) {
                new Carousel('.' + this._carouselSelector, {
                    type: 'popup'
                });
            }
        }
    }

    close(target) {
        if (target.classList.contains('show')) {
            document.body.style.overflow = '';
            this._main.classList.remove('popup-open');
            target.classList.remove('show');
            target.classList.add('hide');
        }
    }
}

module.exports = Popup;